// Central place to route runtime errors. Always logs to the console (as before);
// additionally forwards to window.Sentry / window.onErrorReport if the host page
// wires one up, and keeps a small rolling buffer in sessionStorage so the last
// few errors survive a reload for support/debugging purposes.
const MAX_BUFFERED_ERRORS = 20;

export const logError = (error, info) => {
    // eslint-disable-next-line no-console
    console.error('Error:', error, info);

    try {
        const entry = {
            message: error?.message || String(error),
            stack: error?.stack,
            info,
            time: new Date().toISOString(),
        };

        if (typeof window !== 'undefined') {
            if (window.Sentry?.captureException) {
                window.Sentry.captureException(error, { extra: info });
            } else if (typeof window.onErrorReport === 'function') {
                window.onErrorReport(entry);
            }

            const key = 'app_error_log';
            const existing = JSON.parse(sessionStorage.getItem(key) || '[]');
            existing.push(entry);
            while (existing.length > MAX_BUFFERED_ERRORS) existing.shift();
            sessionStorage.setItem(key, JSON.stringify(existing));
        }
    } catch {
        // Logging must never itself throw.
    }
};
